import {convertAmount, getMeasures, getUnitDatas, ImperialMeasureEquivalence, cleanSymbol} from "@/common/helpers";
import store from "@/store";
import {mapState} from "vuex";

const mixins = {
    computed: {
        ...mapState({
            categories: state => state.settings.categories
        })
    },
    methods: {
        async generateFiltersArray(responseData){
            return new Promise((resolve) => {
                let attributes = responseData;
                let filters = [];
                attributes.forEach(async (attribute,index) => {
                    let filter_datas = null;
                    let storedFilter = this.$store.state.searchMachines.filters.find(x => x.attribute === attribute.code)

                    // Si le filtre existe dans le store, alors on le charge
                    if (storedFilter) {
                        filter_datas = storedFilter;
                    }
                    // Sinon on charge le filtre avec les données par défaut
                    else {

                        filter_datas = {
                            type: attribute.filter_details.type,
                            attribute: attribute.code,
                            title: attribute.label,
                            isTypeFilter: !!attribute.filter_details.is_type_filter,
                            key:index
                        };

                        if (attribute.filter_details.type === "slider") {
                            let unitType = store.state.settings.unitType;
                            let measures = await getMeasures();

                            let measure = null;
                            let min = null;
                            let max = null;
                            let unit_code = null;

                            //if(unitType === 'metric' || 1==1){
                                measure = await getUnitDatas(attribute.filter_details.unit);
                                min = Math.floor(attribute.filter_details.min.replace(',','.'));
                                max = Math.ceil(attribute.filter_details.max.replace(',','.'));
                                unit_code = attribute.filter_details.unit;
                            //}
                            //else if(unitType === 'imperial'){
                            //    let imperialMeasure = ImperialMeasureEquivalence(attribute.unit);
                            //    measure = measures.find(x => x.code === imperialMeasure)
                            //    if(measure){
                            //        min = Math.floor(convertAmount(parseInt(attribute.filter_details.min), measure));
                            //        max = Math.ceil(convertAmount(parseInt(attribute.filter_details.max), measure));
                            //        unit_code = measure.code;
                            //    }
                            //}

                            filter_datas = {
                                ...filter_datas,
                                ...{
                                    slider: [min, max],
                                    minValue: min,
                                    maxValue: max,
                                    min: min,
                                    max: max,
                                    interval: 1,
                                    unit: (measure !== undefined ? cleanSymbol(measure.symbol) : null),
                                    unit_code: unit_code,
                                    formatter: `{value} ` + (measure !== undefined ? cleanSymbol(measure.symbol) : null)
                                }
                            }
                        }
                        else if (attribute.filter_details.type === "select") {
                            if (attribute.options.length > 0) {
                                // On ajoute la valeur "Tout" par défaut sur tout les selects
                                attribute.options.unshift({
                                    code: '',
                                    label: this.$t('all_xy')
                                });

                                filter_datas = {
                                    ...filter_datas,
                                    ...{
                                        value: attribute.options[0].code,
                                        options: attribute.options
                                    }
                                }
                            }
                            else {
                                filter_datas = null;
                            }
                        }
                        else if (attribute.filter_details.type === "boolean") {
                            filter_datas = {
                                ...filter_datas,
                                ...{
                                    value: '',
                                    options: [
                                        {
                                            code: '',
                                            label: this.$t('all_xy')
                                        },
                                        {
                                            code: true,
                                            label: this.$t('yes')
                                        },
                                        {
                                            code: false,
                                            label: this.$t('no')
                                        }
                                    ]
                                }
                            }
                        }
                    }



                    if (filter_datas) {
                        filters.push(filter_datas);
                    }
                });
                resolve(filters)
            });
        },

        findBaseCategory(code) {
            var category=this.categories.find((x)=>x.code===code)
            if(category.parent==='machines') return category;
            else return this.findBaseCategory(category.parent);
        }
    }
};

export default mixins;
